import { render, staticRenderFns } from "./Escort.vue?vue&type=template&id=67d2a827&scoped=true"
import script from "./Escort.vue?vue&type=script&lang=js"
export * from "./Escort.vue?vue&type=script&lang=js"
import style0 from "./Escort.vue?vue&type=style&index=0&id=67d2a827&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d2a827",
  null
  
)

export default component.exports